import {USER_ROOT_API_URL} from "../../../../config/settings.js"

export const GET_BLOCKED_USERS = USER_ROOT_API_URL + "/get_blocked_users"
export const GET_BLOCKED_USERS_COUNT = USER_ROOT_API_URL + "/count_blocked_users"
